import React, { PureComponent } from "react";

class Timestamp extends PureComponent {
  render() {
    let d = this.props.date;
    if (typeof d !== "string") {
      d = d.map(it => {
        return [it, <br />];
      });
    }

    return (
      <div className="timeline-box">
        <div className="date">{d}</div>
        <div className="content">
          {this.props.content}
          <div className="smallc">{this.props.note}</div>
        </div>
      </div>
    );
  }
}

const Timeline = ({ Message: msg }) => (
  <section
    id="timeline"
    style={{ backgroundImage: "Url(images/section-background-02.jpg)" }}
  >
    <div className="container">
      <div className="section-title">
        <h2>{msg.timeline}</h2>
      </div>
      <div className="row">
        <div className="col-md-7 offset-md-3">
          {msg.timelineData.map(it => {
            return (
              <Timestamp
                key={it.date}
                date={it.date}
                content={it.desc}
                note={it.note}
              />
            );
          })}
          {/* <Timestamp date="20 Jan 2020" content="Registration Opens" />
          <Timestamp date="14 Feb 2020" content="Registration Closes" />
          <Timestamp
            date="End-Feb 2020"
            content="Series of Training Bootcamps"
          />
          <Timestamp
            date="13 Mar 2020"
            content="Challenge Day"
            note="(Guest-of-Honour: Ms Sim Ann, Senior Minister of State, Ministry of Communications and Information & Ministry of Culture, Community and Youth)"
          /> */}
        </div>
      </div>
      {/* <div className="section-footer">
      </div> */}
    </div>
  </section>
);

export default Timeline;
